import { rankCorrectionEnum } from '../../../types/stat';
import { AttackPokemonData } from "../../../types/attack"
import RankSelectField from '../../../components/RankSelectField';
import { Typography } from '@mui/material';

interface OffencePokemonRankInputProps {
  attackPokemon: AttackPokemonData
  getRankTypeForMove: (move: any) => string
  handleUpdateRankCorrection: (id: string, rankCorrection: rankCorrectionEnum) => void
}

function OffencePokemonRankInput({
  attackPokemon,
  getRankTypeForMove,
  handleUpdateRankCorrection
}: OffencePokemonRankInputProps) {
  if (!attackPokemon.selectedMove) {
    return null;
  }

  return (
    <div className="mr-1 flex flex-col items-center gap-2">
      <div className="flex flex-col items-center gap-1">
        <Typography variant="caption" sx={{ fontSize: '0.7rem', lineHeight: 1, color: '#333' }}>
          {getRankTypeForMove(attackPokemon.selectedMove)}
        </Typography>
        <RankSelectField
          value={attackPokemon.rankCorrection || 0}
          onChange={(value) => handleUpdateRankCorrection(attackPokemon.id, value as rankCorrectionEnum)}
          stopPropagation
        />
      </div>
    </div>
  );
}

export default OffencePokemonRankInput
